import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UptakelandingComponent } from './uptakelanding/uptakelanding.component';
import { ConfigModule } from '@spartacus/core';
import { InitialuptakeComponent } from './initialuptake/initialuptake.component';
import { InpactcomponentComponent } from './inpactcomponent/inpactcomponent.component';
import { StepbystepComponent } from './stepbystep/stepbystep.component';



@NgModule({
  declarations: [
    UptakelandingComponent,
    InitialuptakeComponent,
    InpactcomponentComponent,
    StepbystepComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents:{
        SeqirusUptakeAcceleratorComp:{
          component:UptakelandingComponent
        },
        StartUptakeComponent:{
          component:InitialuptakeComponent
        },
        SeqirusUptakeAcceleratorDetailComp:{
          component:StepbystepComponent
        },
        StartUptakeComponent2:{
          component:InpactcomponentComponent
        },
      
      }
    })
  ]
})
export class UPTAKEModule { }
